//
// Goal Calculator
//
// Handles calculations for historic and income based goals

import { Controller } from '@hotwired/stimulus'
import debounce from 'lodash/debounce'
import AutoNumeric from 'autonumeric'

export default class extends Controller {
  static targets = [
    'amount',
    'baseAmount',
    'percentage',
    'category',
    'historicalBase',
    'historicalPercentage',
    'historicalCustom',
    'incomeBase',
    'incomePercentage',
    'incomeCustom',
  ]

  connect() {
    this.amount = this.amountTarget.value
    this.category = this.categoryTarget.value
    this.render()
  }

  // When opening the container with calculator, set the default category
  open() {
    // console.log('open', this.category)
    if (
      !this.category ||
      this.category.length < 1 ||
      this.category == 'custom'
    ) {
      this.category = 'income'
      this.categoryTarget.value = 'income'
    }
  }

  // Rerender when changing the amount
  changeAmount(event) {
    const el = event.currentTarget
    this.amount = el.value
    this.render()
  }

  // Rerender when changing the category
  changeCategory(event) {
    const el = event.currentTarget
    this.category = el.getAttribute('data-calculator-type')
    this.render({ skipAmount: true })
  }

  // Rerender when changing the custom percentage
  changeCustomPercentage(event) {
    const el = event.currentTarget
    if (this.category == 'income') {
      this.incomePercentageTarget.value = el.value
      this.calculate()
    } else if (this.category == 'historical') {
      this.historicalPercentageTarget.value = el.value
      this.calculate()
    }
  }

  // Perform calculations to derive total amount from historical/income
  calculate() {
    let baseAmount, percentage
    if (this.category == 'income') {
      if (!this.incomeBaseTarget.value || !this.incomePercentageTarget.value) {
        return
      }
      baseAmount = parseFloat(this.incomeBaseTarget.value) || 0.0
      percentage = parseFloat(this.incomePercentageTarget.value) || 0.0

      if (percentage >= 1) {
        percentage = percentage * 0.01
      }
      this.amount = baseAmount * percentage
    } else if (this.category == 'historical') {
      if (!this.incomeBaseTarget.value || !this.incomePercentageTarget.value) {
        return
      }
      baseAmount = parseFloat(this.historicalBaseTarget.value) || 0.0
      percentage = parseFloat(this.historicalPercentageTarget.value) || 0.0

      if (percentage >= 1) {
        percentage = percentage * 0.01
      }
      this.amount = Number((baseAmount * (1.0 + percentage)).toFixed(2))
    } else {
      // noop
    }
    this.render()
  }

  render(skipAmount) {
    if (!skipAmount) {
      // this.amountTarget.value = this.amount
      AutoNumeric.set(this.amountTarget, this.amount)
    }
    this.percentageTarget.value = this.percentage || ''
    this.baseAmountTarget.value = this.baseAmount || this.amount || ''
  }
}

